<template>
    <div>
        <ts-page-title
            :title="$t('position.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('position.pageTitle'),
                    active: true
                }
            ]"
        />
        <ts-panel>
            <ts-panel-wrapper>
                <div class="tw-flex tw-justify-between tw-items-center">
                    <div>
                        <a-button
                            type="primary"
                            @click="addNew"
                            v-if="$can('create-positions')"
                        >
                            {{ $t("addNew") }}
                        </a-button>
                    </div>
                    <div class="tw-space-x-3">
                        <a-tooltip :title="$t('position.search')">
                            <a-input-search
                                v-model="search"
                                :placeholder="$t('position.search')"
                                style="width: 200px"
                            />
                        </a-tooltip>
                    </div>
                </div>
            </ts-panel-wrapper>
            <ts-table
                :columns="columns"
                :records="resources"
                :loading="loading"
            >
                <template v-slot="{ record }">
                    <td>
                        {{ record.position_name_en }}
                    </td>
                    <td>
                        {{ record.position_name_kh }}
                    </td>
                    <td class="tw-text-center">
                        <span
                            v-if="record.attributes.interchangeable"
                            class="tw-px-2 bg-green-400 tw-text-white tw-rounded"
                            >Yes</span
                        >
                        <span
                            v-else
                            class="tw-px-2 bg-red-400 tw-text-white tw-rounded"
                            >No</span
                        >
                    </td>
                    <td class="text-center tw-space-x-3">
                        <a
                            v-if="
                                $can('update-positions') && !record.is_deleted
                            "
                            href="#"
                            v-tooltip="$t('edit')"
                            class="text-primary mr-2"
                            @click.prevent="edit(record)"
                        >
                            <i class="fas fa-edit"></i>
                        </a>
                        <a-popconfirm
                            v-if="
                                $can('delete-positions') && !record.is_deleted
                            "
                            placement="leftTop"
                            :title="$t('are_you_sure_to_delete')"
                            :ok-text="$t('yes')"
                            :cancel-text="$t('no')"
                            @confirm="deleteRecord(record)"
                        >
                            <a href="#" :disabled="record._deleting">
                                <i
                                    class="fas fa-circle-notch spin"
                                    v-if="record._deleting"
                                ></i>
                                <i class="fa fa-trash text-red" v-else></i>
                            </a>
                        </a-popconfirm>
                    </td>
                </template>
            </ts-table>
            <div class="d-flex justify-content-end tw-p-4">
                <ts-pagination
                    v-model="pagination"
                    @navigate="fetchData"
                ></ts-pagination>
            </div>
        </ts-panel>

        <!-- form-action -->
        <a-modal
            v-if="showForm"
            v-model="showForm"
            :title="$t('position.pageTitle')"
            centered
            :maskClosable="false"
            @cancel="clearEdit"
            width="500px"
            :zIndex="1020"
            :footer="null"
        >
            <FormAction @cancel="clearEdit" @fetchData="fetchData" />
        </a-modal>
    </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
import FormAction from "./form.vue";
export default {
    name: "position",
    components: {
        FormAction
    },
    data() {
        return {
            showForm: false,
            loading: false,
            model: {
                position_name_en: "",
                position_name_kh: "",
                attributes: []
            }
        };
    },
    computed: {
        ...mapState("hr/position", ["resources", "pagination"]),
        search: {
            get() {
                return this.$store.state.hr.position.search;
            },
            set(newValue) {
                this.$store.commit("hr/position/SET_SEARCH", newValue);
                this.$store.commit("hr/position/RESET_CURRENT_PAGE");
            }
        },
        columns() {
            return [
                { name: this.$t("position.nameEn"), sortKey: 'position_name_en' },
                { name: this.$t("position.nameKh"), sortKey: 'position_name_kh' },
                {
                    name: this.$t("position.interchangeable"),
                    style: "width: 30px;"
                },
                {
                    name: this.$t("actions"),
                    style: "text-align:center; width: 1px;"
                }
            ];
        }
    },
    methods: {
        fetchData(attributes) {
            this.loading = true;
            this.$store
                .dispatch("hr/position/fetch", { ...attributes })
                .then(() => {
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$notify({ type: "error", text: error.message });
                });
        },
        addNew() {
            this.showForm = true;
        },
        clearEdit() {
            this.showForm = false;
        },
        edit(record) {
            this.$store.commit("hr/position/SET_EDIT_DATA", record);
            this.showForm = true;
        },
        deleteRecord(record) {
            record._deleting = true;
            this.$store
                .dispatch("hr/position/destroy", record.id)
                .then(response => {
                    this.$notify({ type: "success", text: response.message });
                    this.fetchData();
                })
                .catch(error => {
                    this.$toasted.error(error.message);
                })
                .finally(() => {
                    record._deleting = false;
                });
        }
    },
    watch: {
        search: debounce(function() {
            this.fetchData();
        }, 500)
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchData();
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("hr/position/RESET_STATE");
        next();
    }
};
</script>
